import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import { getBreadCrumbsDataByKey } from 'utils/breadcrumbs';
import TaskReportingView from './TaskReportingView/TaskReportingView';
import useReporting from './utils/useReporting';

export default function TaskReportingViewContainer() {
  const { id } = useParams();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const { taskData, taskError, taskLoading } = useReporting({ taskId: id });

  return (
    <>
      <BreadCrumbs
        data={getBreadCrumbsDataByKey({ pathname, t, entity: taskData })}
      />
      <TaskReportingView
        task={taskData}
        taskError={taskError}
        taskId={id}
        taskLoading={taskLoading}
      />
    </>
  );
}
